import { useContext } from 'react'
import { components } from '@digital-commerce/shared-utils'
import { bool, object } from 'prop-types'
import { Typography, Notification, Box } from '@telus-uds/components-web'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useAuthentication from '../../../hooks/useAuthentication'
import { addDashesToPhoneNumber } from '../../../utils/mobility'

const { ShouldRender } = components

const FinancedSubscriberBanner = ({ accessoryGroup, isPurchasedWithPhone }) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const isExistingCustomer = useAuthentication()

  const phoneNumberFormatted = accessoryGroup?.account.sub
    ? addDashesToPhoneNumber(accessoryGroup.account.sub)
    : ''

  return (
    <ShouldRender when={!isPurchasedWithPhone && isExistingCustomer}>
      <Box bottom={3}>
        <Notification variant="branded" copy={lang}>
          <Typography
            variant={{ size: 'medium', bold: true }}
            testID="accessory-financing-subscriber"
          >
            {translate('accessoryFinancing.subscriberBannerContent')}
          </Typography>
          <Typography dataSet={{ 'di-mask': 'true' }} variant={{ size: 'medium' }}>
            {phoneNumberFormatted}
          </Typography>
        </Notification>
      </Box>
    </ShouldRender>
  )
}

export default FinancedSubscriberBanner

FinancedSubscriberBanner.propTypes = {
  accessoryGroup: object.isRequired,
  isPurchasedWithPhone: bool.isRequired
}
